/* Registers Flickity's jQuery plugin when the vendor bundle did not.
   2026-09-06: Flickity now loads ON DEMAND (window.loadFlickity in utilities.js, Turbo 10.0.0
   port), so this also runs from that loader's resolve via window.tiaFlickityBridge, and a
   layout-guard stub (__tiaStub) counts as missing.
   vendors.js ships Flickity and jQueryBridget, but $.fn.flickity was found
   undefined on most loads, so theme code calling $(el).flickity() threw
   "$(...).flickity is not a function" and aborted the product section
   initialisation, leaving the gallery and form area blank until a refresh.
   Loaded with defer immediately after vendors.js, so it always runs after
   Flickity exists and before sections.js / app.js use it. */
(function () {
  function bridge() {
    try {
      if (window.jQuery && window.jQuery.fn &&
          (!window.jQuery.fn.flickity || window.jQuery.fn.flickity.__tiaStub) &&
          window.Flickity && typeof window.jQueryBridget === 'function') {
        window.jQueryBridget('flickity', window.Flickity, window.jQuery);
      }
    } catch (e) {}
  }
  window.tiaFlickityBridge = bridge;
  bridge();
  document.addEventListener('DOMContentLoaded', bridge);
  window.addEventListener('load', bridge);
})();
